import Vue from 'vue'
import VueRouter from 'vue-router'
import Cancelacion from '../views/inicio/Cancelacion.vue'
import VerificacionOTP from '../views/verificacion_otp/VerificacionOTP.vue'
import TerminosCondiciones from '../views/documentos_terminos/TerminosCondiciones.vue'
import AvisoPrivacidad from '../views/documentos_terminos/AvisoPrivacidad.vue'
import ParametrizacionCredito from '../views/credito/ParametrizacionCredito.vue'

import HomeOfertaUnificada from '../views/inicio/HomeOfertaUnificada.vue'

import ActualizaMontoCredito from '../views/credito/ActualizaMontoCredito.vue'
import Beneficios from '../views/altaSocio/Beneficios.vue'
import DatosPersonales from '../views/altaSocio/DatosPersonales.vue'
import DatosDomicilio from '../views/altaSocio/DatosDomicilio.vue'
import Correo from '../views/Correo.vue'
import ContrasenaCMVF from '../views/ContrasenaCMVF.vue'
import CargaComprobanteDom from '../views/carga_documentos/CargaComprobanteDom.vue'
import ConfirmacionOferta from '../views/ConfirmacionOferta.vue'
import AceptacionContratos from '../views/contratos/AceptacionContratos.vue'
import Contrato from '../views/contratos/Contrato.vue'
import CanvasFirmaUsuario from '../views/contratos/CanvasFirmaUsuario.vue'
import Terminacion from '../views/contratos/Terminacion.vue'
import TerminacionActualizacion from '../views/actualizacion_documentos/TerminacionActualizacion.vue'
import TerminosBuro from '../views/contratos/TerminosBuro.vue'
import Comprobante from '../views/contratos/Comprobante.vue'
import Principal from '../views/principal/Principal.vue'
import CargaDocumentos from '../views/carga_documentos/cargaDocumentos.vue'
import SeguimientoAvance from '../views/seguimientoAvance.vue'
import Referencia from '../views/Referencia.vue'
import store from '@/store/index'
import { capitalizeFirstLetter } from '@/utilidades/utilidades'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import {
  obtenerFolioDigitalStorage,
  obtenerMedioContactoStorage,
} from '@/servicios/sessionStorage.js'
// import VueGtag from 'vue-gtag'
import { datadogRum } from '@datadog/browser-rum'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'principal',
    component: Principal,
  },
  {
    path: '/bienvenida',
    redirect: '/parametrizacion',
  },
  {
    path: '/bienvenidaConfianza',
    redirect: '/parametrizacion',
  },
  {
    path: '/bienvenidaConfianzaspd',
    redirect: '/parametrizacion',
  },
  {
    path: '/cancelacion',
    name: 'cancelacion',
    component: Cancelacion,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/verificacion-otp',
    name: 'verificacion otp',
    component: VerificacionOTP,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/parametrizacion',
    name: 'home oferta',
    component: HomeOfertaUnificada,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/parametrizacion-editar',
    name: 'parametrizacion editar',
    component: ParametrizacionCredito,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminos-y-condiciones',
    name: 'terminos y condiciones',
    component: TerminosCondiciones,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/aviso-de-privacidad',
    name: 'aviso de privacidad',
    component: AvisoPrivacidad,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/beneficios',
    name: 'beneficios',
    component: Beneficios,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/datosPersonales',
    name: 'datosPersonales',
    component: DatosPersonales,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/datosDomicilio',
    name: 'datos Domicilio',
    component: DatosDomicilio,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/CanvasFirmaUsuario',
    name: 'CanvasFirmaUsuario',
    component: CanvasFirmaUsuario,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/correo',
    name: 'correo',
    component: Correo,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contrasena',
    name: 'contraseña',
    component: ContrasenaCMVF,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/confirmacion',
    name: 'confirmación',
    component: ConfirmacionOferta,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/aceptacion-contratos',
    name: 'aceptación contratos',
    component: AceptacionContratos,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/contrato',
    name: 'contrato',
    component: Contrato,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminacion',
    name: 'terminación',
    component: Terminacion,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/comprobante',
    name: 'comprobante',
    component: Comprobante,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/comprobante-domicilio',
    name: 'comprobante domicilio',
    component: CargaComprobanteDom,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cargaDocumentos',
    name: 'carga Documentos',
    component: CargaDocumentos,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/actualizaDocumentos',
    name: 'actualiza Documentos',
    component: CargaDocumentos,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/actualizaMonto',
    name: 'actualiza el Monto',
    component: ActualizaMontoCredito,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminacionActualizacion',
    name: 'terminación Actualizacion',
    component: TerminacionActualizacion,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/terminos-buro',
    name: 'TerminosBuro',
    component: TerminosBuro,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/confirmar-terminos-buro',
    name: 'ConfirmarTerminosBuro',
    component: TerminosBuro,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/avanceCredito',
    name: 'SeguimientoAvance',
    component: SeguimientoAvance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/referencia',
    name: 'referencia',
    component: Referencia,
    meta: {
      requiresAuth: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// this.$gtag.event('cargarFolio', {
//   event_category: 'Enter Page',
//   event_label: 'Folio Digital',
//   value: this.folioDigital,
// })
// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (store.getters.EstaAutenticado) next()
//     else next('/')
//   } else {
//     next()
//   }
// })

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title =
      'Crédito Digital | ' + capitalizeFirstLetter(to.name) ||
      'Crédito Digital | Valladolid Caja Financiera'
  })
  // console.log(to, InsertaLogMixin)
  InsertaLogMixin.insertaLog({
    titulo_pantalla: capitalizeFirstLetter(to.name),
  })
  datadogRum.startView({
    name: capitalizeFirstLetter(to.name),
  })
})

router.beforeEach((to, from, next) => {
  const successPos = (position) => {
    const latitude = position.coords.latitude
    const longitude = position.coords.longitude
    store.dispatch('credito/actualizarUbicacion', {
      lon: longitude,
      lat: latitude,
    })
  }

  const errorPos = () => {
    console.error('No se pudo obtener la ubiación')
  }

  navigator.geolocation.getCurrentPosition(successPos, errorPos)

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['sesion/estaAutenticado']) next()
    else
      next({
        path: '/',
        query: {
          folio: obtenerFolioDigitalStorage(),
          m: obtenerMedioContactoStorage(),
        },
      })
  } else {
    next()
  }

  if (
    from.path == '/actualizaDocumentos' &&
    (!to.path == '/terminacionActualizacion' || !to.path == '/confirmacion')
  ) {
    next('/actualizaDocumentos')
  }

  if (store.getters['credito/obtenerConfirmacion']) {
    store.commit('guia/establecerPasoActivo', {
      pasoActivo: to.path.substring(1),
    })

    if (
      to.path == '/aceptacion-contratos' ||
      to.path == '/contrato' ||
      to.path == '/confirmar-terminos-buro' ||
      to.path == '/CanvasFirmaUsuario'
    ) {
      next()
    } else {
      // next('/aceptacion-contratos')
    }
  } else {
    if (store.getters['credito/obtenerFinalizado']) {
      if (to.path == '/terminacion' || to.path == '/comprobante') {
        store.commit('guia/establecerPasoActivo', {
          pasoActivo: to.path.substring(1),
        })
        next()
      } else {
        next('/terminacion')
      }
    } else {
      store.commit('guia/establecerPasoActivo', {
        pasoActivo: to.path.substring(1),
      })
      next()
    }
  }
})

export default router
